<ul>
  <li *ngFor="let attachment of attachments">
    <app-attachments-list-item
      [attachmentView]="attachment"
      [documentType]="documentType"
      [trackingScreenName]="trackingScreenName"
      [trackingObject]="trackingObject"
      (onDeleteAttachmentItem)="onDeleteAttachmentItem.emit($event)"
      (onUpdateAttachmentItem)="onUpdateAttachmentItem.emit($event)"
      (onEditMode)="onEditMode.emit($event)"
    >
    </app-attachments-list-item>
  </li>
</ul>
